import classes from './GhostLoader.module.css';
import { HTMLAttributes } from 'react';

type GhostLoaderProps = HTMLAttributes<HTMLDivElement>;

export const GhostLoader = ({ ...rest }: GhostLoaderProps) => {
  return (
    <div
      className={classes.ghostLoader}
      {...rest}
      role="status"
      aria-live="polite"
    ></div>
  );
};
